








































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Avatar from '@/components/Profil/Avatar.vue'
import AperMembre from '@/components/Groups/AperMembre.vue'
import Alert from '@/components/Alert.vue'
import { IMember } from '@/types/member'
import { getOperationID } from '@/api/operations'
import { ApiService } from '@/api/api.service'
import { nickname } from '@/utils/nickname'

@Component({
    components: { Avatar, AperMembre, Alert },
})
export default class FuturVoisin extends Vue {
    apiService = new ApiService()
    opeId: number
    allUsers = []
    currentAperMember: IMember = null

    showAll = false
    filterMode: '' | 'hobbies' | 'groups' = ''

    async mounted() {
        this.opeId = await getOperationID()
        this.getUsers()
    }

    async getUsers() {
        const usersResp = await this.apiService.getOperationUsers(
            this.opeId,
            this.filterMode
        )
        this.allUsers = usersResp.data
    }

    getNickname(user) {
        if (user.nickname) {
            return user.nickname
        }

        return nickname(user.firstname, user.lastname)
    }

    get users() {
        return this.showAll ? this.allUsers : this.allUsers.slice(0, 5)
    }

    @Watch('users', { deep: true, immediate: true })
    onUsers() {
        requestAnimationFrame(() => {
            const $root = this.$refs.userList as any
            const $popovers = $($root).find('.popover-dismiss') as any

            $popovers.popover({
                trigger: 'hover',
                template: `
                    <div class="popover popover-yvivre p-0 rounded-pill border-0 bg-dark" role="tooltip">
                        <div class="arrow"></div>
                        <h3 class="popover-header"></h3>
                        <div class="popover-body py-1 text-white"></div>
                    </div>
                `,
                container: 'body',
                boundary: 'window',
            })
        })
    }

    showAperMember(member) {
        this.currentAperMember = member
        const memberModal = <any>$(this.$refs.memberModal)
        memberModal.modal('show')
    }

    handleInvitationResp(success: boolean) {
        if (success) {
            ;(<Alert>this.$refs.alert).handleAlert(
                'success',
                'Votre invitation a bien été envoyée'
            )

            const memberModal = <any>$(this.$refs.memberModal)
            memberModal.modal('hide')
        } else {
            ;(<Alert>this.$refs.alert).handleAlert(
                'danger',
                "Votre invitation n'a pas pu être envoyée"
            )
        }
    }
}
